import React, { useState } from 'react';
import { Box, Tabs, Tab, useTheme, useMediaQuery, Typography } from '@mui/material';
import Positions from './Positions';

function Portfolio() {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Add touch handling to prevent parent scroll
  const handleTouchMove = (event) => {
    const element = event.currentTarget;
    const isAtTop = element.scrollTop === 0;
    const isAtBottom = element.scrollHeight - element.scrollTop === element.clientHeight;

    if ((isAtTop && event.touches[0].clientY > 0) ||
      (isAtBottom && event.touches[0].clientY < 0)) {
      event.preventDefault();
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
      bgcolor: 'background.default',
      overflow: 'hidden',
      [theme.breakpoints.down('sm')]: {
        height: 'calc(100vh - 112px)',
        position: 'fixed',
        top: 56,
        left: 0,
        right: 0,
        bottom: 56
      }
    }}>
      <Box sx={{
        width: '100%',
        bgcolor: 'background.paper',
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: 'sticky',
        top: 0,
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2,
        minHeight: 40
      }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            '& .MuiTabs-indicator': {
              height: 2,
              backgroundColor: theme.palette.primary.main
            },
            minHeight: 40,
            flex: 1
          }}
        >
          <Tab
            label="Positions"
            sx={{
              textTransform: 'none',
              minHeight: 40,
              px: 0,
              mr: 3,
              color: activeTab === 0 
                ? theme.palette.primary.main 
                : theme.palette.text.secondary
            }}
          />
        </Tabs>
      </Box>

      <Box 
        onTouchMove={handleTouchMove}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          overflow: 'hidden',
          touchAction: isMobile ? 'none' : 'auto',
          WebkitOverflowScrolling: 'touch',
          overscrollBehavior: 'none',
          height: isMobile ? 'calc(100% - 40px)' : '100%'
        }}
      >
        {activeTab === 0 ? (
          <Box sx={{
            flex: 1,
            position: 'relative',
            overflow: 'hidden',
            height: '100%',
            pb: isMobile ? '56px' : 0
          }}>
            <Positions />
          </Box>
        ) : (
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
          }}>
            <Typography 
              variant="h6" 
              color="text.secondary"
            >
              Holdings Coming Soon
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default Portfolio;
